/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by randysorensen on 8/15/16.
 */

//
// Glossary:
//
//		"group" - shown as "Type" in the UI. Examples are Package, Partner Package,
// 			Partner-specific, Series, Movie/Special, Volume, etc.
//
//		"uiControlHint" - shown as "Component" in the UI. Examples are CheckBox, List,
//			TextInput, etc.
//
//		"type" - should be "string", or "picklist" for lists
//
//		"ownerClass" - either "package", "nonPackage" or "partnerSpecific"
//

'use strict';

function MetadataItemEditModalController(_, $q, $routeParams, MetadataEditService, PartnerResourceFactory) {
	var self = this;

	var updateGroupName = function () {
	    if (self.resolve.conversion) {
			self.groupNames = ['Media Conversion'];
        } else if (self.metadataItem.groupIds === undefined) {
			self.groupNames = (self.groupList && self.groupList.length === 1) ? self.groupList : '';
		} else {
			MetadataEditService.getGroupNamesByIds(self.metadataItem.groupIds).then(function (groupNames) {
				self.groupNames = groupNames;
			});
		}
	};

	var updatePartners = function () {
		self.selectedPartners = [];
		if (self.resolve.ownerClass === 'partner') {
			angular.forEach(self.metadataItem.partnerIds, function (partnerId) {
				self.selectedPartners.push(self.partnerDict[partnerId]);
			});
		}
	};

	var getPartnerList = function () {
		if (self.resolve.ownerClass === 'partner') {
			return PartnerResourceFactory.query({fetchLimit: -1})
            .$promise.then(function (partners) {
				self.partnerDropdownCollection = angular.copy(partners);
				self.partnerDict = {};
				angular.forEach(self.partnerDropdownCollection, function (partner) {
					self.partnerDict[partner.id] = partner;
				});
				updatePartners();
			});
		}
	};

	var syncPropToForm = function () {
		updateGroupName();

		if (self.isPickList()) {
			self.picklistItems = self.metadataItem.picklistItems;
		}

		self.component = self.componentDict[self.metadataItem.uiControlHint];

		if (!!self.metadataItem.preferredWidth) {
			self.preferredWidth = self.preferredWidthLookup[self.metadataItem.preferredWidth];
		}
        if (self.resolve.conversion) {
            self.metadataItem.excludeFromMetadata = true;
        }

		updatePartners();
	};

	var syncFormToProp = function () {
		MetadataEditService.getGroupIdsByNames(self.groupNames).then(function (groupIds) {
			self.metadataItem.groupIds = groupIds;
		});

		self.metadataItem.uiControlHint = self.component.label;
		self.metadataItem.multiple = self.component.label === 'CheckboxList';
		self.metadataItem.type = self.isPickList() ? 'picklist' : 'string';
		if (self.isPickList()) {
			self.metadataItem.picklistItems = self.picklistItems;
		} else {
			delete self.metadataItem.picklistItems;
		}

		if (!!self.preferredWidth && self.preferredWidth.length > 0) {
			self.metadataItem.preferredWidth = self.preferredWidthDict[self.preferredWidth];
		} else {
			delete self.metadataItem.preferredWidth;
		}

		delete self.metadataItem.partnerIds;
		if (self.resolve.ownerClass === 'partner') {
			self.metadataItem.partnerIds = [];
			angular.forEach(self.selectedPartners, function (partner) {
				self.metadataItem.partnerIds.push(partner.id);
			});
		}
	};

	var getFormData = function () {
		let ownerClass = (self.resolve.mvpd) ? 'nonPackage' : self.resolve.ownerClass;
		let promises = [];
        promises.push(MetadataEditService.getGroupList(ownerClass)
            .then(function (groups) {
                if (self.resolve.mvpd) {
                    _.remove(groups, (group) => group === 'Ad/PreRoll');
                }
                self.groupList = groups;
                updateGroupName();
            })
        );

		if (self.resolve.propertyId >= 0) {
            promises.push(MetadataEditService.getPropertyById(self.resolve.propertyId)
                .then(function (prop) {
                    self.metadataItem = prop;
                    syncPropToForm(prop);
                })
            );
		}

		return $q.all(promises);
	};

	self.$onInit = function () {
        self.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
		if (self.resolve.ownerClass === 'partner') {
			self.metadataItem.partnerIds = [$routeParams.id];
		}
        if (self.resolve.conversion) {
            self.metadataItem.excludeFromMetadata = true;
        }

        self.loadingIndicator.show = true;
		$q.all([
            getPartnerList(),
            getFormData(),
        ]).then(function () {
            self.loadingIndicator.show = false;
        });
	};

	self.metaItemEditForm = undefined;
	self.tooltipTemplate = 'components/modal/metadata-item-editor/component-previews-template.html';

	// This includes all of the data for the component preview tooltips.
	self.componentDict = {
		CheckBox: {model: true},
		CheckboxList: {
			items: [
				{id: 1, displayName: 'Item 1'},
				{id: 2, displayName: 'Item 2'},
				{id: 3, displayName: 'Item 3'},
				{id: 4, displayName: 'Item 4'}
			],
			model: [1, 2]
		},
		DateField: {model: new Date('2016/08/24')},
		DateFieldEnhanced: {model: new Date('2016/08/24')},
		DateTimeField: {model: new Date('2016-08-24T22:07:31.000+0000')},
		DateTimeFieldEnhanced: {model: new Date('2016-08-24T22:07:31.000+0000')},
		DropDownList: {
			collection: [
				{label: 'Item 1'},
				{label: 'Item 2'},
				{label: 'Item 3'}
			]
			// model: { label: 'Item 1' }
		},
		List: {
			items: [
				{label: 'Item 1'},
				{label: 'Item 2'},
				{label: 'Item 3'},
				{label: 'Item 4'},
				{label: 'Item 5'}
			],
			model: 'Item 2'
		},
		TextArea: {model: 'preview text'},
		TextInput: {model: 'preview text'},
		TimeCodeInput: {model: '01:00:19:34'},
		TimeInput: {model: '16:07:31'},
		TextListInput: {
			items: [
				{stringValue: '/path1'},
				{stringValue: '/path1'},
				{stringValue: '/path1'},
				{stringValue: '/path1'}
			]
		}
	};
	if (self.resolve.conversion) {
        self.componentDict = _.pick(self.componentDict, [
            'CheckBox', 'DropDownList', 'TextArea', 'TextInput', 'TimeCodeInput'
        ]);
    }

	self.componentList = [];
	angular.forEach(self.componentDict, function (component, componentLabel) {
		component.label = componentLabel;
		self.componentList.push(component);
	});

	self.preferredWidthDict = {Small: '25', Medium: '50', Large: '75', Full: '100'};	// lookup label -> percent
	self.preferredWidthLookup = {};														// lookup percent -> label
	self.preferredWidthList = [];														// for UI dropdown
	angular.forEach(self.preferredWidthDict, function (width, widthLabel) {
		self.preferredWidthList.push(widthLabel);
		self.preferredWidthLookup[width] = widthLabel;
	});

	self.selectedPartners = [];
	self.partnerDropdownCollection = [];
	self.partnerDict = {};

	self.component = self.componentList[0];
	self.groupList = [];
	self.groupName = '';
	self.picklistItems = [];
	self.preferredWidth = '';
	self.metadataItem = {
		id: -1,
		uiControlHint: self.component.label,
		type: 'string',
		multiple: false,
		advanced: false,
		synchronizeClips: false,
		liveUpdate: false,
		alwaysLive: false,
		searchable: false,
        visible: true,
		excludeFromMetadata: false,
		requiredAdPreRoll: false,
		requiredLongMovie: false,
		requiredLongSeason: false,
		requiredLongVolume: false,
		requiredShortMovie: false,
		requiredShortSeason: false,
		requiredShortVolume: false
	};

	self.showDisplayWidth = function () {
		switch (self.metadataItem.uiControlHint) {
			case 'CheckboxList':
			case 'DropDownList':
			case 'List':
			case 'TextArea':
			case 'TextInput':
				return true;
			default:
				return false;
		}
	};

	self.showMaxCharacterCount = function () {
		switch (self.metadataItem.uiControlHint) {
			case 'TextArea':
			case 'TextInput':
				return true;
			default:
				return false;
		}
	};

	self.isPickList = function () {
		switch (self.metadataItem.uiControlHint) {
			case 'CheckboxList':
			case 'DropDownList':
			case 'List':
				return true;
			default:
				return false;
		}
	};

	self.canSave = function () {
		return (
			(!!self.metadataItem.displayName && self.metadataItem.displayName.length > 0) &&
			(!!self.groupNames && self.groupNames.length > 0) &&
			((self.isPickList() && self.picklistItems.length > 0) || !self.isPickList()) &&
			(!!self.metaItemEditForm && !self.metaItemEditForm.$pristine) &&
			(self.resolve.ownerClass !== 'partner' || self.selectedPartners.length > 0));
	};

	self.onPicklistChange = function () {
		self.metaItemEditForm.$setDirty();
	};

	self.onSave = function () {
		syncFormToProp();
		self.close({$value: self.metadataItem});
	};

	self.showPartnerFlags = function () {
		return self.resolve.ownerClass === 'partner';
	};
}

angular.module('prism-ui.components').component('metadataItemEditModal', {
	templateUrl: 'components/modal/metadata-item-editor/metadata-item-edit-modal-template.html',
	controller: MetadataItemEditModalController,
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	}
});
